import {
    FAILED_STATUS,
    FAILURE, REGISTER,
    SUCCESS,
    SUCCESS_STATUS,
    UNKNOWN_STATUS,
} from '../constants/constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (next) => async (action) => {
    if (!action.apiData) return next(action);

    const { apiData, type, ...rest } = action;
    // Registration API returns a bit different response structure.
    const payload = apiData?.data;
    let operationStatus;
    if (type === REGISTER) {
        operationStatus = !!payload?.payment_page_token ? SUCCESS_STATUS : FAILED_STATUS;
    } else {
        operationStatus = payload?.operation_status;
    }

    switch (operationStatus) {
        case FAILED_STATUS:
            const message = !!payload?.account_exists
                ? 'Account already exists'
                : payload?.operation_message
            next({ ...rest, type: type + FAILURE, error: message });
            break;
        case SUCCESS_STATUS:
            next({ ...rest, type: type + SUCCESS, data: payload });
            break;
        default:
            next({ ...rest, type: type + FAILURE, error: UNKNOWN_STATUS, data: payload });
    }
};
